export function list(deleted) {
  return {
    type: 'user_list',
    payload: {
      request: {
        url: '/user/list',
        params: {
          deleted: deleted
        }
      }
    }
  }
};

export function update(data) {
  return {
    type: 'user_update',
    payload: {
      request: {
        url: '/user/update',
        method: 'POST',
        data: data
      }
    }
  }
}


// WEBPACK FOOTER //
// ./client/axios/users.js